import { useEffect, useRef, useState } from "react";
import { CiSearch } from "react-icons/ci";

export default function CustomPlacesCheckbox({ value = [], onSelect }) {
  const [input, setInput] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [selected, setSelected] = useState(value);
  const serviceRef = useRef(null);
  const detailsServiceRef = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => {
    setTimeout(() => inputRef.current.focus(), 50);
  },[])
  useEffect(() => {
    if (window.google) {
      serviceRef.current = new window.google.maps.places.AutocompleteService();
      detailsServiceRef.current = new window.google.maps.places.PlacesService(
        document.createElement("div")
      );
    }
  }, []);

  const handleInput = (e) => {
    const value = e.target.value;
    setInput(value);

    if (!value || !serviceRef.current) return;

    serviceRef.current.getPlacePredictions(
      { input: value },
      (predictions = []) => {
        console.log(predictions)
        setSuggestions(predictions);
      }
    );
  };

  const fetchPlaceDetails = (placeId,placeDescription) => {
    return new Promise((resolve, reject) => {
      detailsServiceRef.current.getDetails(
        {
          placeId,
          fields: ["address_components", "name"],
        },
        (place, status) => {
          if (status === window.google.maps.places.PlacesServiceStatus.OK) {
            const country = place.address_components.find((c) =>
              c.types.includes("country")
            );
            const state = place.address_components.find((c) =>
              c.types.includes("administrative_area_level_1")
            );

            console.log(country)

            resolve({
              place_id: placeId,
              name: place.name,
              countryName: country?.long_name || "",   
              countryIsoCode: country?.short_name || "",
              stateIsoCode: state?.short_name || "",
              description: placeDescription,
            });
          } else {
            reject(status);
          }
        }
      );
    });
  };

  const toggleSelect = async (place) => {
    const exists = selected.find((s) => s.place_id === place.place_id);
    let newSelection;

    if (exists) {
      // remove
      newSelection = selected.filter((s) => s.place_id !== place.place_id);
    } else {
      // fetch details
      const details = await fetchPlaceDetails(place.place_id,place?.description);
      newSelection = [...selected, details];
    }

    setSelected(newSelection);
    onSelect?.(newSelection);
    setSuggestions([])
    setInput('')
  };


  const removeSelectedPlace = async (place) => {
     let newSelection;
    newSelection = selected.filter((s) => s.place_id !== place.place_id);
    setSelected(newSelection);
    onSelect?.(newSelection);
  }

  return (
    <div className="custom-autocomplete">
      <div className="address-search-bar">
        <span>
          <CiSearch size={"18px"} />
        </span>
        <input
          
          type="text"
          value={input}
          onChange={handleInput}
          placeholder="Search places..."
       
          ref={inputRef}
        />
      </div>

      {
        selected.length === 0 && suggestions.length === 0 && <div>
        <p style={{margin:"3px 0px",background:'#e7eff7',fontSize: "13px",    padding: "5px 10px"}}>
          Search for and select all destinations for your trip (e.g. resort name, point of interest, address, countries)
        </p>
      </div>
      }
      

       {selected.length > 0 && (
        <div
          className="dropdown"
          style={{ display: "flex", flexDirection: "column" }}
        >
          {selected.map((s) => (
            <label
              key={s.place_id}
              className="option"
              style={{
                padding: "10px 20px",
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <input
                type="checkbox"
                checked={true}
                onChange={() => removeSelectedPlace(s)}
                style={{
                  flex: "initial",
                  width: "fit-content",
                  transform: "scale(1.5)",
                }}
              />
              {s.description}
            </label>
          ))}
        </div>
      )}
      {suggestions.length > 0 && (
        <div
          className="dropdown"
          style={{ display: "flex", flexDirection: "column" }}
        >
          {suggestions.map((s) => (
            <label
              key={s.place_id}
              className="option"
              style={{
                padding: "10px 20px",
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <input
                type="checkbox"
                // checked={selected.some((sel) => sel.place_id === s.place_id)}
                disabled={selected.some((sel) => sel.place_id === s.place_id)}
                onChange={() => toggleSelect(s)}
                style={{
                  flex: "initial",
                  width: "fit-content",
                  transform: "scale(1.5)",
                }}
              />
              {s.description}
            </label>
          ))}
        </div>
      )}
    </div>
  );
}
